import * as React from 'react';
import { useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import { Stack } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import logo from '../Assets/logo.png'
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import Config from '../../Config.json';
import axios from 'axios';
import StyledMenu from './MenuCustom.js'
import { useNavigate } from "react-router-dom";

import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

import Dialog from '@mui/material/Dialog';
import ProfileDialog from './ProfileDialog.js';
import DialogTitle from '@mui/material/DialogTitle';
import MailboxDialog from './MailboxDialog.js';
import SignupLogin from '../SignupLogin.js';

import EastOutlinedIcon from '@mui/icons-material/EastOutlined';

import LanguageSelector from '../LanguageSelector.js';
import LanguageIcon from '@mui/icons-material/Language';

import Cookies from 'js-cookie';

import "/node_modules/flag-icons/css/flag-icons.min.css";
import LoginIcon from '@mui/icons-material/Login';
import SettingsDialog from "../SettingsDialog.js"

// import Cookies from 'universal-cookie';


const pages = ['About', 'Contact'];

function WallAppBar(props) {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const [profilePicLink, setProfilePicLink] = React.useState("");
  const [givenName, setGivenName] = React.useState("");  

  const [origFlag, setOrigFlag] = React.useState("us");
  const [destFlag, setDestFlag] = React.useState("fr");

  // 0 = login, 1 = signup
  const [loginOrSignUp, setLoginOrSignup] = React.useState(0);

  // 0 = no dialog open, 1 = dialog #1 open, and so on.
  const[dialogOpenState, setDialogOpenState] = React.useState(0);
  const [avatarAnchorEl, setAvatarAnchorEl] = React.useState(null);



  const avatarOpen = Boolean(avatarAnchorEl);

  function setDialogAndCount(dialogState, count) {
    if (props.setStartCounting !== undefined) {
      props.setStartCounting(count)
    }
    setDialogOpenState(dialogState);
  }
  const handleAvatarClick = (event) => {
    setAvatarAnchorEl(event.currentTarget);
  };

  const handleAvatarClose = () => {
    setAvatarAnchorEl(null);
  };

  const handleOpenNavMenu = (event) => {
    if (props.setStartCounting !== undefined) {
      props.setStartCounting(false);
    }
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    if (props.setStartCounting !== undefined) {
      props.setStartCounting(true);
    }
    setAnchorElNav(null);
  };

  const handleOpenUserMenu = (event) => {
    if (props.setStartCounting !== undefined) {
      props.setStartCounting(false);
    }
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    if (props.setStartCounting !== undefined) {
      props.setStartCounting(true);
    }
    setAnchorElUser(null);
  };

  const handleClick = () => {
    props.toggleDrawer(!props.drawerState);
  }

  const handleLogout = () => {
    // remove session id and user-specific cookies

    //TODO: send Logout request to backend so session can be set as invalid.
    setProfilePicLink("");
    var sid = Cookies.get("session_id")
    Cookies.remove('session_id');
    Cookies.remove('user_destLang');
    Cookies.remove('user_origLang');
    window.location.reload();
    // TODO: send to backend to set session as invalid
  }

  let navigate = useNavigate(); 

  const routeChange = (path) =>{
    // console.log('changing route    ')
    navigate(path);
  }

  function openSignupLoginDialog(newVal) {
    setLoginOrSignup(newVal);
    setDialogAndCount(3, false);
    // setDialogOpenState(3);
  }

  function handleSetOrigFlag(newFlag) {
    // TODO: if logged in, send post request to update user preferences 
    if (profilePicLink == "") {
      // console.log('setting anon_origLang to', newFlag)
      Cookies.set("anon_origLang", newFlag);
    } else {
      axios.post(Config.urlStub + "/updateUserPref", 
        // countryLangMapping
        //TODO: updateUserPref using right langCode for orig and dest flags!!
        {"origLang":Config.countryLangMapping[newFlag] },
        { withCredentials: true }
      )
      .then((response) => {
        return true;
      }).catch(function (error) {
        console.log(error);
      })
      console.log('setting user_origLang to', newFlag)
      Cookies.set("user_origLang", newFlag);
    }

    setOrigFlag(newFlag);
    window.location.reload();
  }

  function handleSetDestFlag(newFlag) {
    
    // TODO: if logged in, send post request to update user preferences
    if (profilePicLink == "") {
      console.log('setting anon_destLang to', newFlag)
      Cookies.set("anon_destLang", newFlag);
    } else {
      axios.post(Config.urlStub + "/updateUserPref", 
        // countryLangMapping
        //TODO: updateUserPref using right langCode for orig and dest flags!!
        {"destLang":Config.countryLangMapping[newFlag] },
        { withCredentials: true }
      )
      .then((response) => {
        return true;
      }).catch(function (error) {
        console.log(error);
      })
      // console.log("user detected, setting user destLang")
      Cookies.set("user_destLang", newFlag);
    }
    setDestFlag(newFlag);
    window.location.reload();
  }

  function getProfileDisplay() {

    axios.post(Config.urlStub + "/getUserInfo", 
        {},
        { withCredentials: true })

  //   axios.post(Config.urlStub + "getUserInfo", {"session_id":Cookies.get('session_id')},
  //   // axios.post(Config.userInfoUrl, {"session_id":Cookies.get('session_id')},
  //   {  crossDomain: true, withCredentials: true, origin: "http://localhost:3000" }
  // )
  .then((response) => {
      // console.log(response.data.profile_pic);
      setProfilePicLink(response.data.profile_pic);
      setGivenName(response.data.given_name);
      Cookies.set("user_origLang", Config.langCountryMapping[response.data.origLang]);
      Cookies.set("user_destLang", Config.langCountryMapping[response.data.destLang]);
      // TODO: set user cookies with user preferences from response body
      return true;
    }).catch(function (error) {
      console.log(error);
      console.log("getProfileDisplay not ok")
      return false;
    })
  }  

  useEffect(() => {
    if (!getProfileDisplay()) {
      if (Cookies.get("anon_origLang") === undefined) {
        // set default cookies if none are detected
        console.log("setting anon origLang cookie")
        Cookies.set("anon_origLang", "us");
      } 
      if (Cookies.get("user_origLang") !== undefined) {
        setOrigFlag(Cookies.get("user_origLang"));
      } else {
        setOrigFlag(Cookies.get("anon_origLang"));
      }

      if (Cookies.get("anon_destLang") === undefined) {
        // set default cookies if none are detected; prioritize user settings if logged in
        Cookies.set("anon_destLang", "fr");
      } 
      if (Cookies.get("user_destLang") !== undefined) {
        setDestFlag(Cookies.get("user_destLang"));
      } else {
        console.log("anon cookie detected, updating state to",Cookies.get("anon_destLang"));
        setDestFlag(Cookies.get("anon_destLang"));
      }
    } else {
      console.log("getProfileDisplay OK")
    }
  }, [])

  return (
    <GoogleOAuthProvider clientId={Config.oAuthClientId}>
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, mb:2, bgcolor: "green" }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>

          <a href='/'>
          <img  src={logo} alt="logo"/>
          </a>
          
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/app"
            sx={{
              ml: 2,
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            vocabslab
          </Typography>
          

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-haspopup="true"
              onClick={handleOpenUserMenu}
              color="inherit"
            >
              <LanguageIcon />
            </IconButton> 
            {/* anchorElUser */}

            <Menu
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              <Box sx={{width:'200px'}}>
              <MenuItem onClick={() => 0} sx={{mr:'200px', width:'100%'}} style={{whiteSpace: 'normal'}}>
                  Click flags to choose languages
                </MenuItem>
                <MenuItem onClick={handleCloseNavMenu} sx={{mr:'200px', width:'100%'}}>
                {/* <Typography sx={{mr:'200px', width:'100px'}} textAlign="center">Select Dest Lang</Typography>
                 */}
                 <LanguageSelector flag={origFlag} updateFlag={handleSetOrigFlag} /> 
                </MenuItem>
                <MenuItem onClick={handleCloseNavMenu} sx={{mr:'200px', width:'100%'}}>
                  <LanguageSelector flag={destFlag} updateFlag={handleSetDestFlag}  />
                  
                </MenuItem>
                </Box>
            </Menu>


            <IconButton
              size="large"
              aria-haspopup="true"
              color="inherit"
              onClick={handleOpenNavMenu}
            >
              <MenuIcon/>
            </IconButton>

            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              <Box sx={{width:'125px'}}>
                <MenuItem onClick={() => routeChange("/words")} sx={{mr:'200px', width:'100%'}}>
                  <Typography sx={{mr:'200px', width:'100px'}} textAlign="center">Words</Typography>
                </MenuItem>
                <MenuItem onClick={() => routeChange("/app")} sx={{mr:'200px', width:'100%'}}>
                  <Typography sx={{mr:'200px', width:'100px'}} textAlign="center">Quiz</Typography>
                </MenuItem>
                <MenuItem onClick={() => routeChange("/rapidfire")} sx={{mr:'200px', width:'100%'}}>
                  <Typography sx={{mr:'200px', width:'100px'}} textAlign="center">Rapid Fire</Typography>
                </MenuItem>
                <MenuItem onClick={() => routeChange("/about")} sx={{mr:'200px', width:'100%'}}>
                  <Typography sx={{mr:'200px', width:'100px'}} textAlign="center">About</Typography>
                </MenuItem>
                </Box>
            </Menu>
          </Box>


          {/* <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} /> */}
          <Typography
            variant="6"
            noWrap
            component="a"
            href="/app"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            vocabslab
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent:'center', alignItems:'center'}}>

              <Button
                onClick={() => routeChange("/words")}
                sx={{ my: 2, mr:5, color: 'white', display: 'block' }}
              >
                Words
              </Button>

              <Button
                onClick={() => routeChange("/app")}
                sx={{ my: 2, mr:5, color: 'white', display: 'block' }}
              >
                Quiz
              </Button>

              <Button
                onClick={() => routeChange("/rapidfire")}
                sx={{ my: 2, mr:5, color: 'white', display: 'block' }}
              >
                Rapid Fire
              </Button>

              <Button
                onClick={() => routeChange("/about")}
                sx={{ my: 2, mr:5, color: 'white', display: 'block' }}
              >
                About
              </Button>
              
              <Stack direction="row" sx={{minWidth:'100px', mb:1, ml:1 }}>
                <LanguageSelector flag={origFlag} updateFlag={handleSetOrigFlag} sx={{mr:2,}}  />
                  <EastOutlinedIcon sx={{"color":"black", ml:1, mr:0.5, mt:2, size:'small'}}/>
                <LanguageSelector flag={destFlag} updateFlag={handleSetDestFlag} sx={{mr:2,}} />
              </Stack>
              
          </Box>

          

          { profilePicLink === "" &&  
          <Stack direction="row">          
            <Button onClick={() => openSignupLoginDialog(0) } 
            sx={{color:"white", display: { xs: 'none', md: 'flex' }, mr:2 }}
            ><b>Login</b></Button>

            <Button onClick={() => openSignupLoginDialog(1) } 
            sx={{color:"white", display: { xs: 'none', md: 'flex' } }}
            >Sign up</Button>

            <Tooltip title="Login / Signup">
            <IconButton sx={{color:"white", display: { xs: 'flex', md: 'none' } }}
            onClick={() => setDialogAndCount(3, false) } >
            <LoginIcon/>
          </IconButton>
          </Tooltip>
          </Stack>
            }
            
            {
              profilePicLink !== "" &&
              <Stack direction="row" sx={{ display: { xs: 'flex', md: 'flex' }, mr:3, justifyContent:'flex-end', alignItems:'center'}} >
              <Button id="basic-button" onClick={handleAvatarClick} aria-controls={avatarOpen ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={avatarOpen ? 'true' : undefined}>

<Typography variant="h6"
              noWrap
              sx={{
                ml: 2,
                mr: 1,
                display: { xs: 'none', md: 'flex' },
                fontWeight: 400,
                fontSize:15,
                color:"white"
              }}>
                {givenName}
              </Typography>
          
                <Avatar src={profilePicLink} sx={{ width: 36, height: 36 }}/>
              </Button>

              
                <StyledMenu sx={{ width: 320,  }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                id="basic-menu"
                anchorEl={avatarAnchorEl}
                open={avatarOpen}
                onClose={handleAvatarClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                <MenuItem onClick={() => setDialogAndCount(1, false)}><PersonIcon/>Profile</MenuItem>
                <MenuItem onClick={() => setDialogAndCount(4, false)}><SettingsIcon/>Settings</MenuItem>
                <MenuItem onClick={handleLogout}><LogoutOutlinedIcon/>Logout</MenuItem>
                </StyledMenu>

              </Stack>
            }

          <Dialog open={dialogOpenState===1} onClose={() => setDialogAndCount(0, true)}>
            <DialogTitle>Edit Profile</DialogTitle>
            <ProfileDialog/>
          </Dialog>

          <Dialog open={dialogOpenState===2} onClose={() => setDialogAndCount(0, true)}>
            <DialogTitle>Mailbox</DialogTitle>
            <MailboxDialog/>
          </Dialog>

          <Dialog open={dialogOpenState===3} onClose={() => setDialogAndCount(0, true)}>
            {/* <DialogTitle>Signup or Login</DialogTitle> */}
            <SignupLogin 
              getProfileDisplay={getProfileDisplay} 
              signUpOrLogin={loginOrSignUp}
              closeDialog={() => setDialogOpenState(0) }
            />
          </Dialog>

          <Dialog open={dialogOpenState===4} onClose={() => setDialogAndCount(0, true)}>
            <SettingsDialog closeDialog={() => setDialogOpenState(0) }/>
          </Dialog>

          
        </Toolbar>
      </Container>
    </AppBar>
    </GoogleOAuthProvider>
  );
}
export default WallAppBar;